import { render, staticRenderFns } from "./GetManagedLabs.vue?vue&type=template&id=50f76ec0&scoped=true"
import script from "./GetManagedLabs.vue?vue&type=script&lang=js"
export * from "./GetManagedLabs.vue?vue&type=script&lang=js"
import style0 from "./GetManagedLabs.vue?vue&type=style&index=0&id=50f76ec0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f76ec0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VBtn,VFlex,VForm,VLayout})
